<template>
  <div>
    <header class="head-wrap" style="height: 100px;">
      <div class="header-title" style="height: 70px;">
        <img class="title-icon" src="../../static/logo.png" alt="">
      </div>
      <div class="head-prompt" style="height: 30px; display: inline-block;">
        <div class="date-wrap" style="float: right; ">
          <a style="color: red;">{{ date }}</a>
          <a style="color: red;">|</a>
          <a style="color: red;">{{ status }}</a>
        </div>
      </div>
    </header>

  </div>
</template>

<script>
import {EventBus} from '../common/eventBus'

export default {
  name: 'HeaderOther',
  data () {
    return {
      date: '连接中',
      status: '--'
    }
  },
  created () {
    if (!this.GLOBAL.socket || this.GLOBAL.socket.readyState !== WebSocket.OPEN) {
      console.log(this.GLOBAL.socket)
      this.connectWebSocket()
    }
    EventBus.$on('dateUpdated', updatedDate => {
      this.date = updatedDate
    })
    EventBus.$on('statusUpdated', updatedStatus => {
      this.status = updatedStatus
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/HeaderOther.vue